import { Directive, inject, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Directive()
export abstract class BaseModalComponent implements OnInit, OnDestroy {
    protected modalCtrl = inject(ModalController);
    protected platform = inject(Platform);
    protected navCtrl = inject(NavController);

    backButtonBlockSub: Subscription | null = null;

    public close(): void {
        this.modalCtrl.dismiss(null, 'cancel').then();
    }

    ngOnInit(): void {
        this.backButtonBlockSub = this.platform.backButton.subscribeWithPriority(9999, () => {
            console.log('backButtonBlockSub base-modal.compnent');
            this.close();
        });
    }

    ngOnDestroy(): void {
        this.backButtonBlockSub?.unsubscribe();
    }
}
